import request from "@/utils/request";

// 分页查询
export function queryModelList(data) {
  return request({
    url: "/process/page",
    method: "post",
    data,
  });
}

// 查询(不分页)
export function queryModelListNotLimit(data) {
  return request({
    url: "/process/list",
    method: "Post",
    data,
  });
}

// 根据id查询
export function queryModelById(id) {
  return request({
    url: `/process/${id}`,
    method: "get",
  });
}

// 新增
export function insertModel(data) {
  return request({
    url: "/process/save",
    method: "post",
    data,
  });
}

// 编辑
export function updateModel(data) {
  return request({
    url: "/process/update",
    method: "post",
    data,
  });
}

// 部署
export function deployModel(id) {
  return request({
    url: `/process/deploy/${id}`,
    method: "post",
  });
}

//删除
export function deleteModel(id) {
  return request({
    url: `/process/delete/${id}`,
    method: "delete",
  });
}
